import { Component, OnInit } from '@angular/core';
import { GetServerDataServiceService } from '../get-server-data-service.service';
import * as converter from 'number-to-words';

@Component({
  selector: 'app-print-view-payment-voucher-bills',
  templateUrl: './print-view-payment-voucher-bills.component.html',
  styleUrls: ['./print-view-payment-voucher-bills.component.css']
})
export class PrintViewPaymentVoucherBillsComponent implements OnInit {

  constructor(
    private server: GetServerDataServiceService
  ) { }

  date = "";
  company_name = "company_name";
  amount = "0";
  VoucherNo = "VoucherNo";
  Description = "";
  Account = "";
  amountInWords = "";
  grnNos = "";
  username = "";
  paidMode = "";
  Supplier = "";
  SupplierAddress = "";
  SupplierCity = "";

  ngOnInit(): void {
    this.setValues();
  }

  print(): void {
    window.print();
  }

  setValues() {
    if (localStorage.printView) {
      const printView = JSON.parse(localStorage.printView);

      this.server.get_company_name().subscribe(res => {
        this.username = localStorage.username;
        this.company_name = res[0]['Company Name'];
        this.date = printView['Paid Date'];
        this.amount = printView['Paid Amount'];
        this.VoucherNo = printView['Voucher Code'];
        this.Description = printView.Description;
        this.Account = printView.Account;
        this.amountInWords = converter.toWords(this.amount).toLocaleUpperCase() + " RUPEES.";
        this.paidMode = printView['Paid By'];
        this.Supplier = printView.Supplier;
        this.SupplierAddress = printView['Supplier Address'];
        this.SupplierCity = printView['Supplier City'];

        this.server.payment_vouchers_bills_print_row(printView['Voucher Code'])
          .subscribe(res => {
            const grnNoList = [];
            res.map((e:any) => {
              grnNoList.push(e['GRN No']);
            });
            this.grnNos = grnNoList.join();
          });
      });

      console.log(printView);
    }
  }

}
